module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Heavy-bc1c996658eecdd3f3d20a75bb195cd7.woff";